module.exports = __webpack_public_path__ + "assets/img/8_1674_big.40ad6fb9.jpg";